export default {
  templates: [],
}
